import { Component, OnInit, ViewChild, ElementRef, Input, TemplateRef } from '@angular/core'
import { BehaviorSubject } from 'rxjs'; 

import { sla, kpiRelease, kpiband, kpiViewHistory, kpiInbox, kpi, kpiViewWorkFlow, slakpiInteraction, year} from './../../../models/slakpi';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import Swal from 'sweetalert2';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';

@Component({
  selector: 'kpi-allhistory',
  templateUrl: './kpi-allhistory.component.html',
  styleUrls: ['./kpi-allhistory.component.css']

})
export class KPIAllHistoryComponent implements OnInit {

  public kpiMapping_data: any;
  public kpiRelease_data_count: any;
  public kpiViewWorkflow_data: any;
  public kpiTargetHistory_data: any;
  public interaction_data: any;
  public fields_mappings: Object;
  public yearData: any;
  public quaterData: any;
  public yearUno_chart: number =0;
  public quaterUno_chart: number = 0;
  public kpirUno_chart: number = 0;
  //@Input('kpiUno')
  kpiUnoSelected: number = 0;
  @Input() set kpiUno(value: number) {
    this.bSubject.next(value);
  }
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  public kpiViewHistory_data: any;
  public kpiCodeDetail: kpi;
  public historyStartIndex: number = 1;
  public historyMaxCount: number = 50;
  historydisableMore: boolean = true;
  public isDataEntryError: boolean = false;
  public txtDataEntryError: string = '';

 
  //@ViewChild("inpyeardata", { static: false }) inpyeardata: DropDownListComponent;
  //@ViewChild("inpquaterdata", { static: false }) inpquaterdata: DropDownListComponent;
  //@ViewChild("inpyeardata_chart", { static: false }) inpyeardata_chart: DropDownListComponent;
  //@ViewChild("inpquaterdata_chart", { static: false }) inpquaterdata_chart: DropDownListComponent;
 
 

  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public workflowStartIndex: number = 1;
  public workflowMaxCount: number = 300;
  workflowdisableMore: boolean = true;
  public selectedIndex: number = 0;
  //public loggined_User: number = 2;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  tenantUno?: number;
  isToggle: boolean = true;
  public isAdmin: boolean = false;
  public isPageEdit: boolean = false;
  private bSubject = new BehaviorSubject(0);
  public condition3_data: any;
  //for Edit
  modalRef: BsModalRef;
  public kpiRuleForm1: FormGroup;
  public kpiCodeDetail1: kpiInbox;
  public NANRVal1: string = '';
  public band_calculated1: string = '';
  public kpiTrnUno1: number = 0;
  public kpiViewBand_data1: any;
  public actualTargetValue1: number;
  public position_dataentry1: object = { X: 500, Y: 300 };
  public position_band1: object = { X: 550, Y: 340 };
  @ViewChild('KPIDataEntryDialog1', { static: false }) KPIDataEntryDialog1: TemplateRef<any>;
  @ViewChild('BandDialog1', { static: false }) BandDialog1: TemplateRef<any>;
  public actualTrend: string = '';
  //Initializing Primary X Axis
  public primaryXAxis: Object = {
    valueType: 'Category'
  };
  public primaryYAxis: Object = {
    title: 'Value',
    majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
    minorGridLines: { width: 1 }, minorTickLines: { width: 0 }
  };
 
  public titlechart = 'KPI Chart';
  public zoomSettings: Object = {
    mode: 'X',
    enableMouseWheelZooming: true,
    enablePinchZooming: true,
    enableSelectionZooming: true,
    enableScrollbar: true
  };
  public ChartKPIdata: any;
  public marker: Object;
  public tooltip: Object;
  public palette: string[];
  noDataImg: any;
  constructor(public restApi: SLAKPIApiService, public adminService: AdminApiService, private modalService: BsModalService, private toaster: ToasterService,
    private userService: UserService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService) {

    this.bSubject.subscribe(value => {

      if (value != 0) {
        this.kpirUno_chart = value;
        this.selectedIndex = 0;
        this.kpiUnoSelected = value;
        this.loadKPICodeDetails(value);
        //this.loadKPIViewHistory(value, true);
        this.user = this.userService.getUserInfo();
        this.login_UserID = this.user.id;
        this.currentYear = this.user.currentYear;
        this.viewKPIChart(this.kpirUno_chart, false);
       
        this.loadKPIRelease(5, value);
        this.loadKPIWorkflow(true, value);
        this.loadKPITargetHistory(value);
        this.condition3_data = [
          { text: 'Pass', value: 'Pass' },
          { text: 'Fail', value: 'Fail' },
        ];
        this.loadFilterValues();
        this.tooltip = { enable: true };
        this.marker = {
          visible: true, width: 10, height: 10, dataLabel: { visible: true },border: { width: 2, color: 'red' },
          rx: 10, ry: 10
        };
        this.palette = ["#07682d", "#e34867", "#6FAAB0", "#C4C24A"];

      }
    });

  }


  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: false,

      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };

    this.toolbar = ['Search'];
    this.kpiViewHistory_data = [];
    this.pageSettings = { pageSize: 20, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    //this.viewKPI(this.kpiUnoSelected);
    this.kpiRuleForm1 = new FormGroup({
      justification: new FormControl(),
      enteredTargetValue: new FormControl(),
      selectNANR: new FormControl(),
      selectPassFail: new FormControl()
    });
    this.kpiCodeDetail1 = new kpiInbox();
    this.isPageEdit = false;
    if (this.router.url.indexOf('kpiadmin')>0){
      this.isPageEdit = true;
    }
  }
  selectionChange(selectionEvent: any) {

  }
  viewKPI(kpiUno: any) {
    
    this.bSubject.next(kpiUno);
  }


  // Get kpi release list
  loadKPIReleaseOld(condition, kpino) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.spinner.show();
    let inpValue = new kpiRelease();
    inpValue.languageUno = 1033;
    inpValue.itemUno = (condition == 5) ? kpino : 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = 0;
    inpValue.slayear = 0;
    inpValue.slaquarter = 0;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;
    inpValue.divisionUno = 0;
    inpValue.frequencyUno = 0;

    this.restApi.getKpiRelease(inpValue)
      .subscribe(data => {
        if (condition == 5) {
          this.kpiMapping_data = data;
          setTimeout(() => {
          //this.groupMappingOptions = { columns: ['year', 'quarter'] };

          }, 100);

        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }





  //Get KPI History
  loadKPIViewHistory(kpiUno: number, isStart) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.spinner.show();
    let inpValue = new kpiViewHistory();
    inpValue.kpiUno = kpiUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;;
    this.historyStartIndex = (this.historyStartIndex == undefined || this.historyStartIndex < 1 || isStart) ? 1 : this.historyStartIndex;
    inpValue.startIndex = this.historyStartIndex;
    inpValue.maxCount = this.historyMaxCount;

    this.restApi.getkpiViewHistory(inpValue)
      .subscribe(data => {

        let objData: any = data;

        if (this.historyStartIndex == 1) {
          this.kpiViewHistory_data = [];
          this.kpiViewHistory_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewHistory_data.push(objData[i]);
          }
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.historydisableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.historyStartIndex = this.historyStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.spinner.show();
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = kpiTrnUno;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKPIs(inpValue)
      .subscribe(data => {

        this.kpiCodeDetail = data[0];

        //this.KPIViewDialog.show();
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI View KPI Workflow
  loadKPIWorkflow(isStart, kpino) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.spinner.show();
    let inpValue = new kpiViewWorkFlow();
    inpValue.kpiTrnUno = 0;
    inpValue.languageUno = 1033;
    inpValue.itemUno = kpino;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.workflowStartIndex = (this.workflowStartIndex == undefined || this.workflowStartIndex < 1 || isStart) ? 1 : this.workflowStartIndex;
    inpValue.startIndex = this.workflowStartIndex;
    inpValue.maxCount = this.workflowMaxCount;

    this.restApi.getInddividualKpiViewKPIWorkflow(inpValue)
      .subscribe(data => {

        let objData: any = data;

        if (this.workflowStartIndex == 1) {
          this.kpiViewWorkflow_data = [];
          this.kpiViewWorkflow_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewWorkflow_data.push(objData[i]);
          }
        }
        const mockDataset = [];
        for (let i = 0; i < this.kpiViewWorkflow_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            kpiYearName: this.kpiViewWorkflow_data[i].kpiYearName,
            kpiQuarterName: this.kpiViewWorkflow_data[i].kpiQuarterName,
            action: this.kpiViewWorkflow_data[i].action,
            comment: this.kpiViewWorkflow_data[i].comment,
            postedBy: this.kpiViewWorkflow_data[i].postedBy,
            postedDate: this.kpiViewWorkflow_data[i].postedDate
          };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setCommentDefn();
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.workflowdisableMore = (objData.length >= 300) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.workflowStartIndex = this.workflowStartIndex + 1;
        }
        setTimeout(() => {

          //this.groupWorkflowOptions = { columns: ['kpiYearName', 'kpiQuarterName'] };
        }, 100);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setCommentDefn() {
    this.columnDefinitions = [
      { id: 'kpiYearName', name: 'Year', field: 'kpiYearName', sortable: true },
      { id: 'kpiQuarterName', name: 'Action', field: 'kpiQuarterName', sortable: true },
      { id: 'action', name: 'User Action', field: 'action', sortable: true },
      { id: 'comment', name: 'Comments', field: 'comment', sortable: true },
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Action Date', field: 'postedDate', sortable: true },

    ];
  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
  }
  getInnerArrValue(data: any) {
    
    return data.objKPIViewWorkflowStatic;
  }
  //Get KPI View KPI Workflow
  loadKPITargetHistory(kpino) {
    
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.spinner.show();
    let inpValue = new kpiViewWorkFlow();
    inpValue.kpiTrnUno = 0;
    inpValue.languageUno = 1033;
    inpValue.itemUno = kpino;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
   
    this.restApi.getKPITargetValueHistory(inpValue)
      .subscribe(data => {

        this.kpiTargetHistory_data= data;
       // setTimeout(() => { this.groupWorkflowOptions = { columns: ['kpiYearName', 'kpiQuarterName'] }; }, 100);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get SLA&KPI Mapping
  loadKPIRelease(condition, kpino) {
    this.spinner.show();
    let inpValue = new slakpiInteraction();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.yearFilter = 0;
    inpValue.yearFilterDefault = 0;
    inpValue.quaterFilter = 0;
    inpValue.kpiFilter = kpino;

    inpValue.nodedroppedQuater = 0;
    this.interaction_data = [];
    this.restApi.getSLAKPIMappingsHistory(inpValue)
      .subscribe(data => {
         

        this.interaction_data = data;
        
          this.fields_mappings = { dataSource: this.interaction_data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };

        
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  viewKPIChart(kpiUno: any, isFilter: boolean) {
    if (!isFilter) {
      //if (this.inpyeardata_chart)
      //this.inpyeardata_chart.value = Number(this.currentYear);
      this.yearUno_chart = this.currentYear;
      this.quaterUno_chart = 0;
    }

    this.ChartKPIdata = null;
    //Get The Chart Value
    
   //this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = this.yearUno_chart;
    inpValue.kpiQuarter = this.quaterUno_chart;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKpiYearWiseChart(inpValue)
    .subscribe(data => {

      
    //   public data: Object[] = [
    //  { group: { x: 'USA', y: 10 }, y: 20 },
    //  { group: { x: 'China', y: 30 }, y: 10 }
    //];

      
      setTimeout(() => {
        this.ChartKPIdata = data;
      }, 600);

      //if (!isFilter) {
      //  if (this.inpyeardata_chart)
      //    this.inpyeardata_chart.value = Number(this.currentYear);
      //}
       

      },
        (error) => {
          //Called when error
         // this.spinner.hide();

        }
      ).add(() => {
       // //Called when operation is complete (both success and error)
      //  this.spinner.hide();

      });



  }
  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {

        let objdata: any = data;       
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  //For Data Entry Edit --only for admin
  DataEntryKPI(objData: any) {
    
    this.isDataEntryError = false;
    this.txtDataEntryError = '';
    this.kpiTrnUno1 = objData.kpiTrnUno;
    this.kpiViewBand_data1 = new kpiband();
    this.kpiRuleForm1 = new FormGroup({
      justification: new FormControl(),
      enteredTargetValue: new FormControl(),
      selectNANR: new FormControl(),
      selectPassFail: new FormControl()
    });

    this.loadKPICodeDetails1(objData.kpiTrnUno);
  }
  //Get KPI Code Details
  loadKPICodeDetails1(kpiTrnUno: number) {
    
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.NANRVal1 = '';
    this.restApi.getKpiCodeDetails(inpValue)
      .subscribe(data => {
        
        //this.data = data;
        if (data != null && data != undefined) {
       
          this.modalRef = this.modalService.show(
            this.KPIDataEntryDialog1,
            Object.assign({}, {
              class: 'gray modal-lg',
              backdrop: true,
              keyboard: true,
              focus: true,
              show: false,
              ignoreBackdropClick: true,
              animated: true
            })
          );
          this.kpiRuleForm1.get('enteredTargetValue').enable();
          this.kpiRuleForm1.get('selectPassFail').enable();
          //this.kpiCodeDetail = new kpiInbox();
          this.kpiCodeDetail1 = data[0];
          if (this.kpiCodeDetail1 != null) {
            this.NANRVal1 = '';
            this.actualTargetValue1 = parseFloat(this.kpiCodeDetail1.actualValue != '' ? this.kpiCodeDetail1.actualValue : '0');
            this.actualTrend = this.kpiCodeDetail1.trendUno;
            this.kpiRuleForm1.setValue({
              enteredTargetValue: this.kpiCodeDetail1.targetValue,
              justification: this.kpiCodeDetail1.dataOwnerComments,
              selectNANR: (this.kpiCodeDetail1.isNANRNT == 'NA' ? true : false),
              selectPassFail: this.kpiCodeDetail1.passFail
            });
            if (this.kpiCodeDetail1.isNANRNT == 'NA') {
              this.kpiRuleForm1.get('enteredTargetValue').reset();
              this.kpiRuleForm1.get('enteredTargetValue').disable();

              this.kpiRuleForm1.get('selectPassFail').reset();
              this.kpiRuleForm1.get('selectPassFail').disable();
              this.NANRVal1 = 'NA';
              this.band_calculated1 = 'gray-bar';
            }
            if (this.kpiCodeDetail1.bandColour != '') {
              this.band_calculated1 = (this.kpiCodeDetail1.bandColour == 'Red') ? 'red-bar' :
                (this.kpiCodeDetail1.bandColour == 'Orange') ? 'orange-bar' :
                  (this.kpiCodeDetail1.bandColour == 'Yellow') ? 'yellow-bar' :
                    (this.kpiCodeDetail1.bandColour == 'Light Green') ? 'light-green-bar' : (this.kpiCodeDetail1.bandColour == 'Green') ? 'green-bar' : 'gray-bar';
            }
            else {
              this.band_calculated1 = 'gray-bar';
            }
          }
          this.loadKPIViewBand(this.kpiCodeDetail.kpiUno, this.kpiCodeDetail1.kpiYear, this.kpiCodeDetail1.scheduleUno, this.kpiCodeDetail1.bandScheduleTypeUno);

          //this.kpiUno = data[0].kpiUno;
          //this.scheduleUno_gloabl = data[0].scheduleUno;
          //this.getSchduleTypeNo();
          //this.actualTargetValue = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '') ? parseInt(this.kpiCodeDetail.actualValue) : 0;
          //this.checkCurrentUserAndLevel(data);


        }

        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI Band
  loadKPIViewBand(kpiUno: number, defaultyear: number, scheduleUno: number, bandScheduleTypeUno: number) {
    
    this.spinner.show();
    let inpValue = new kpiband();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = defaultyear;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.scheduleUno = scheduleUno;
    inpValue.scheduleTypeUno = bandScheduleTypeUno;
    this.restApi.getkpiViewBand(inpValue)
      .subscribe(data => {
        
        this.kpiViewBand_data1 = data[0];

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  onSubmit(slaRuleUno: number, type: string) {
    

    this.isDataEntryError = false;
    this.txtDataEntryError = '';
    let selectNANR = null;
    let comment = '';
    let targetEnValue = 0;
    let passfail = '';
    //Get Selected Vlaues
    selectNANR = (this.NANRVal1 == null || this.NANRVal1 == undefined) ? '' : 'NA';
    let objTargetEnValue = this.kpiRuleForm1.get('enteredTargetValue').value;
    comment = 'Admin Editted the Value';//this.kpiRuleForm1.get('justification').value;

    //Set Target if Rule is text [Pass--100 / Fail --0]
    if (slaRuleUno == 4) {
      passfail = (this.kpiRuleForm1.get('selectPassFail') != null) ? this.kpiRuleForm1.get('selectPassFail').value : '';
      if (selectNANR != 'NA') {
        if (passfail == undefined || passfail == null || passfail == '') {
          //Swal.fire('Error', 'Please Select Pass/Fail', 'error');
          this.txtDataEntryError = 'Please Select Pass/Fail';
          this.isDataEntryError = true;
          return false;
        }
      }
    }

    //Target Value validation
    targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseFloat(objTargetEnValue) : 0;
    //if ((this.txtTarget.value == null || this.txtTarget.value.toString() == '' || objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
    if (targetEnValue == 0 && selectNANR == '' && (slaRuleUno == 1 || slaRuleUno == 2)) {
      //Swal.fire('Error', 'Please Enter the Actual Value', 'error');
      //return false;
      targetEnValue = 0;
    }



    //Comment require
    
    if (this.NANRVal1 != '' || passfail == 'Fail') {
      // let comment = this.kpiRuleForm.get('comment').value;
      if (comment == '' || comment == null) {
      //  Swal.fire('Error', 'Please Enter the Justification', 'error')
       // return false;
      }
    }

    let objKPIView = new kpiViewWorkFlow();
    objKPIView.action = 'Send for Approval by Data Owner';
    objKPIView.selectedNANR = this.NANRVal1;
    objKPIView.kpiTrnUno = this.kpiTrnUno1;
    objKPIView.comment = (comment == null || comment == undefined) ? '' : comment;
    objKPIView.userUno = this.login_UserID;
    objKPIView.passFail = passfail;
    objKPIView.targetEnteredValue = targetEnValue;
    objKPIView.condition = 0;//(this.pageAction == "add") ? 0 : 1;
    objKPIView.saveAction = type;
    

    if (slaRuleUno == 1 || slaRuleUno == 2 || slaRuleUno == 3) {


      let classname: string = '';
      let band1Value1 = this.kpiViewBand_data1.band1Value1;
      let band2Value1 = this.kpiViewBand_data1.band2Value1;
      let band3Value1 = this.kpiViewBand_data1.band3Value1;
      let band4Value1 = this.kpiViewBand_data1.band4Value1;
      let band5Value1 = this.kpiViewBand_data1.band5Value1;
      let band1Condition1 = this.kpiViewBand_data1.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data1.band2Condition1;

      if (targetEnValue > this.actualTargetValue1) {
        //Swal.fire('Error', ' Target Value should <=' + this.actualTargetValue1, 'error')
      //  this.txtDataEntryError = 'Actual Value should <=' + this.actualTargetValue1;
        //this.isDataEntryError = true;
        //classname = '';
        //return false;
      }
      let bandfinalcolor = '';
      if (this.NANRVal1 == '') {
        classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
        if (classname == '') { this.band_calculated1 = 'gray-bar'; return false; } else { this.band_calculated1 = classname; }

      }

      //Comment require
      if (classname == 'red-bar') {

        if (comment == '' || comment == null) {
         // Swal.fire('Error', 'Please Enter Justification', 'error')
          //return false;
        }
      }


      if (this.NANRVal1 == '') {
        if (classname == 'red-bar') {
          objKPIView.bandColorFinal = 'Red';
        }
        else if (classname == 'orange-bar') {
          objKPIView.bandColorFinal = 'Orange';
        }
        else if (classname == 'yellow-bar') {
          objKPIView.bandColorFinal = 'Yellow';
        }
        else if (classname == 'light-green-bar') {
          objKPIView.bandColorFinal = 'Light Green';
        }
        else if (classname == 'green-bar') {
          objKPIView.bandColorFinal = 'Green';
        }
      }
      else {
        this.band_calculated1 = 'gray-bar';
      }

      if (type == 'submit') {
        this.modalRef.hide();
        let htmldisplay = (this.NANRVal1 == '') ? '<div style="padding-left:115px"> <table style="border:none"><tr style="border:0;"><td width="10%"> Performance:</td><td> <span class="' + classname + '" style="position:inherit!important"></span></td></table></div>' :
          '<div style="padding-left:115px"> <table style="border:none"><tr style="border:0;"><td width="10%"> Performance: </td><td> <span style="position:inherit!important">NA</span></td></table></div>';
        Swal.fire({
          title: 'Please Confirm to Submit the value',
          html: htmldisplay,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {

            objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }
      
    }
    else {
      if (type == 'submit') {
        let classname = (passfail != '' && passfail == 'Pass') ? 'green-bar' : 'red-bar'
        Swal.fire({
          title: 'Please Confirm to Submit the value',
          html:
            (this.NANRVal1 == '') ? '<div style="padding-left:115px"> <table style="border:none"><tr><td width="10%"> Performance:</td><td> <span class="' + classname + '" style="position:inherit!important"></span></td></table></div>' :
              '<div style="padding-left:115px"> <table style="border:none"><tr><td width="10%"> Performance:</td><td> <span style="position:inherit!important">NA</span></td></table></div>',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {
            if (this.NANRVal1 == '') {
              objKPIView.bandColorFinal = (passfail != '' && passfail == 'Pass') ? 'Green' : 'Red';
              objKPIView.isWellPerformed = (passfail != '' && passfail == 'Pass') ? 1 : 0;
            }
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }
       


    }

    return true;

  }
  deleteKPITran_forAdmin(data: any) {
    Swal.fire({
      title: 'Please confirm to delete the KPI Transaction',      
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {


        let objKPIView = new kpiViewWorkFlow();
        objKPIView.action = 'delete';
        objKPIView.selectedNANR = '';
        objKPIView.kpiTrnUno = data.kpiTrnUno;
        objKPIView.comment = 'Deleted by admin';
        objKPIView.userUno = this.login_UserID;
        objKPIView.passFail = '';
        objKPIView.targetEnteredValue = 0;
        objKPIView.condition = 1;//(this.pageAction == "add") ? 0 : 1;
        objKPIView.saveAction = 'submit';
        this.CallUpdate(objKPIView);

        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    })

  }
  showKPIBand() {
    //this.loadKPIViewBand(this.kpiUno);
   
    this.modalRef = this.modalService.show(
      this.BandDialog1,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  GetBandColorClass1(slaRuleUno: number) {
    
    let targetEnValue = 0;
    //Get Selected Vlaues
    let selectNANR = (this.NANRVal1 == null || this.NANRVal1 == undefined) ? '' : this.NANRVal1;
    if (selectNANR == '') {


      let objTargetEnValue = this.kpiRuleForm1.get('enteredTargetValue').value;
      //Target Value validation
      if ((objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
       // Swal.fire('Error', 'Please Enter the Actual value', 'error')
       // return false;
      }
      targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseFloat(objTargetEnValue) : 0;

      //0-Target Class Get
      if (slaRuleUno == 3) {
        this.band_calculated1 = (targetEnValue == 0) ? "green-bar" : "red-bar";
        return true;
      }

      //Pas/Fail Class Get
      if (slaRuleUno == 4) {
        let passfail = (this.kpiRuleForm1.get('selectPassFail') != null) ? this.kpiRuleForm1.get('selectPassFail').value : '';
        if (passfail == '')
          //Swal.fire('Error', 'Please Select the Pass/Fail option', 'error')
          this.toaster.show('error', 'Please Select the Pass / Fail option');
        this.band_calculated1 = (passfail == 'Fail') ? "red-bar" : "green-bar";
        return true;
      }

      //Other Types Class Get

      if (targetEnValue > this.actualTargetValue1) {
        //Swal.fire('Error', ' Actual Value should <=' + this.actualTargetValue1, 'error')
        //return false;
      }
      this.band_calculated1 = '';
      let band1Value1 = this.kpiViewBand_data1.band1Value1;
      let band2Value1 = this.kpiViewBand_data1.band2Value1;
      let band3Value1 = this.kpiViewBand_data1.band3Value1;
      let band4Value1 = this.kpiViewBand_data1.band4Value1;
      let band5Value1 = this.kpiViewBand_data1.band5Value1;
      let band1Condition1 = this.kpiViewBand_data1.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data1.band2Condition1;
      let classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
      if (classname == '') { this.band_calculated1 = 'gray-bar'; return false; } else { this.band_calculated1 = classname; }


    }
    else {
      this.band_calculated1 = 'gray-bar';
    }

  }

  getBadcolorFinal(slaRuleUno: any, targetEnValue: any, band1Value1: number, band2Value1: number, band3Value1: number, band4Value1: number, band5Value1: number, band1Condition1: number, band2Condition1: number) {
    

    let classname: string = '';
    let targetEnValue_tmp = targetEnValue;
   // if ((this.kpiViewBand_data1.bandtype == 2)) {
     // targetEnValue_tmp = ((targetEnValue / this.actualTargetValue1) * 100).toFixed();
    //}

    if ((this.kpiViewBand_data1.bandtype == 2)) {

      targetEnValue_tmp = ((targetEnValue / this.actualTargetValue1) * 100).toFixed();

    }
    if (slaRuleUno == 2) {
      
      let tr = (this.actualTrend == "1") ? 1 : -1;
      targetEnValue_tmp = (((targetEnValue - this.actualTargetValue1) * tr) / this.actualTargetValue1) * 100;
      targetEnValue_tmp = (targetEnValue_tmp > 100) ? 100 : targetEnValue_tmp;
    }

    if (slaRuleUno == 11) {
      //if (targetEnValue > band5Value1) {
      //Swal.fire('Error', ' Target Value should <=' + band5Value1, 'error')
      //classname='';
      // }

      if (targetEnValue_tmp <= band1Value1) {
        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band2Value1) && (targetEnValue_tmp <= band3Value1)) {

        classname = "orange-bar";
      }
      else if ((targetEnValue_tmp >= band3Value1) && (targetEnValue_tmp <= band4Value1)) {

        classname = "yellow-bar";
      }
      else if ((targetEnValue_tmp >= band4Value1) && (targetEnValue_tmp < band5Value1)) {

        classname = "light-green-bar";
      }
      else if (targetEnValue_tmp >= band5Value1) {

        classname = "green-bar";
      }
    }
    else if (slaRuleUno == 2 || slaRuleUno == 1) {

      // if (targetEnValue > band2Value1) {
      // Swal.fire('Error', ' Target Value should <=' + band2Value1, 'error')
      // classname = ''
      //}

      //if (targetEnValue_tmp <= band1Value1) {
      //  classname = "red-bar";
      //}
      //else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

      //  classname = "green-bar";
      //}
      //else if (targetEnValue_tmp > band2Value1) {

      //  classname = "green-bar";
      //}

      if (
        (targetEnValue_tmp > band1Value1 && band1Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band1Value1 && band1Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band1Value1 && band1Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band1Value1 && band1Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band1Value1 && band1Condition1 == 5)  //conditon type <=
      ) {
        classname = "red-bar";
      }
      if (
        (targetEnValue_tmp > band2Value1 && band2Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band2Value1 && band2Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band2Value1 && band2Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band2Value1 && band2Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band2Value1 && band2Condition1 == 5)  //conditon type <=
      ) {
        classname = "green-bar";
      }
      //entered value is greater than the target value then passed as green (Well performed) -- when performance is empty
      if (classname == '') {
        if (targetEnValue >= this.actualTargetValue1)
          classname = "green-bar";
        else
          //Swal.fire('Error', 'Something went wrong in the KPI Band value configuration.', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong in the KPI Band value configuration.');
      }

    }
    else if (slaRuleUno == 3) {

      
      if (targetEnValue_tmp == 0) {
        classname = "green-bar";
      }
      else {

        classname = "red-bar";
      }

    }

    return classname;
  }

  getWellPerform(slaRuleUno: any, classname: string) {
    let rtnValue: number = 0;
    if (slaRuleUno == 11) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data1.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'orange-bar') {
        rtnValue = (this.kpiViewBand_data1.band2wellperform) ? 1 : 0;
      }
      else if (classname == 'yellow-bar') {
        rtnValue = (this.kpiViewBand_data1.band3wellperform) ? 1 : 0;
      }
      else if (classname == 'light-green-bar') {
        rtnValue = (this.kpiViewBand_data1.band4wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data1.band5wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 2 || slaRuleUno == 1) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data1.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data1.band2wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 3) {
      if (classname == 'red-bar') {
        rtnValue = 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = 1;
      }
    }
    return rtnValue;
  }

  CallUpdate(objKPIView: kpiViewWorkFlow) {
    
    objKPIView.tenantUno = 1;
     
    objKPIView.kpiYear = this.kpiCodeDetail1.kpiYear;
    objKPIView.kpiQuarter = this.kpiCodeDetail1.kpiQuarter;
    objKPIView.kpiUno = this.kpiCodeDetail1.kpiUno;
    objKPIView.kpiNameEn = this.kpiCodeDetail1.kpiNameEn;
    objKPIView.kpiYearName = this.kpiCodeDetail1.kpiYearName;
    objKPIView.kpiQuarterName = this.kpiCodeDetail1.kpiQuarterName;
    objKPIView.targetValue = this.kpiCodeDetail1.targetValue;
    objKPIView.actualTargetValue = this.kpiCodeDetail1.actualTargetValue;
    
    this.restApi.addAdminKpiViewWorkflow(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'KPI Saved Successfully');
          this.kpiRuleForm1.reset();

        }

        this.modalRef.hide();
        this.spinner.hide();
        this.loadKPITargetHistory(this.kpiCodeDetail1.kpiUno);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.modalRef.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
        //  this.KPIDataEntryDialog.show();
      });
    return true;
  }

  onchangeNANR1(e) {
    
    this.NANRVal1 = '';
    if (e != null && e.target.checked) {
      this.NANRVal1 = 'NA';
      this.kpiRuleForm1.get('enteredTargetValue').reset();
      this.kpiRuleForm1.get('enteredTargetValue').disable();

      this.kpiRuleForm1.get('selectPassFail').reset();
      this.kpiRuleForm1.get('selectPassFail').disable();

      this.band_calculated1 = 'gray-bar';

    }
    else {
      this.NANRVal1 = '';
      this.kpiRuleForm1.get('enteredTargetValue').enable();
      this.kpiRuleForm1.get('selectPassFail').enable();
    }
  }
  onchangePassFail(e: any) {
    let passfail = (e && e.length > 0) ? e[0].value :'';
    if (passfail != '') {
      this.band_calculated1 = (passfail == 'Fail') ? "red-bar" : "green-bar";
    }

  }

  onchangeYear(e) {

    this.yearUno_chart = (e.itemData != null) ? e.itemData.value : 0;    
    this.viewKPIChart(this.kpirUno_chart,true);
    //this.filterYear_default = this.yearUno;
    //this.currentYear = this.yearUno;
    //this.storeFilterValues();
    //if (!this.isStart) {
    //  this.loadKPIInbox();
    //  this.loadKPIInboxCount();
    //}
  }

  onchangeQuarter(e) {
    this.quaterUno_chart = (e.itemData != null) ? e.itemData.value : 0;
    this.viewKPIChart(this.kpirUno_chart, true);
    //this.currentQuarter = this.quarterUno;
    //this.filterQuarter_default = this.quarterUno;
    //this.storeFilterValues();
    //this.loadKPIInbox();
    //this.loadKPIInboxCount();
  }

  //public onFilteringYear: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.yearData, query);
  //};
  //public onFilteringQuater: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.quaterData, query);
  //};

}


